import { useState } from 'react';
import fbInsightsLogo from '@/assets/logos/fbinsights/fb_insights_logo_blue.png';
import StartFreeLink from '../../../components/StartFreeLink';

interface NavigationProps {
  scrolled: boolean;
  showMenuItems?: boolean;
}

const links = [
  { id: 'how-it-works', label: 'How It Works' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'faq', label: 'FAQ' },
];

export default function Navigation({ scrolled, showMenuItems = true }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav
      className={`sticky top-0 left-0 right-0 z-50 border-b border-fb-border bg-white/90 backdrop-blur-md transition-shadow ${
        scrolled ? 'shadow-md' : ''
      }`}
    >
      <div className="mx-auto flex max-w-content items-center justify-between gap-6 px-6 py-4 sm:px-8">
        <a href={showMenuItems ? '#top' : '/'} className="flex items-center">
          <img src={fbInsightsLogo} alt="F&B Insights" className="h-9 w-auto" />
        </a>

        {showMenuItems && (
          <>
            {/* Desktop menu */}
            <div className="hidden items-center gap-8 md:flex">
              {links.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="text-[15px] font-medium text-fb-navy transition-colors hover:text-fb-blue"
                >
                  {link.label}
                </a>
              ))}
              <StartFreeLink className="rounded-md bg-fb-blue px-6 py-3 text-[15px] font-semibold text-white transition-colors hover:bg-fb-navy">
                Start Free
              </StartFreeLink>
            </div>

            {/* Mobile toggle */}
            <button
              type="button"
              aria-label="Toggle menu"
              onClick={() => setMobileMenuOpen((open) => !open)}
              className="text-fb-navy md:hidden"
            >
              {mobileMenuOpen ? (
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                >
                  <line x1="6" y1="6" x2="18" y2="18" />
                  <line x1="18" y1="6" x2="6" y2="18" />
                </svg>
              ) : (
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                >
                  <line x1="4" y1="7" x2="20" y2="7" />
                  <line x1="4" y1="12" x2="20" y2="12" />
                  <line x1="4" y1="17" x2="20" y2="17" />
                </svg>
              )}
            </button>
          </>
        )}
      </div>

      {/* Mobile menu */}
      {showMenuItems && mobileMenuOpen && (
        <div className="border-t border-fb-border bg-white px-6 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            {links.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMobileMenuOpen(false)}
                className="text-[15px] font-medium text-fb-navy"
              >
                {link.label}
              </a>
            ))}
            <StartFreeLink
              onClick={() => setMobileMenuOpen(false)}
              className="rounded-md bg-fb-blue px-6 py-3 text-center text-[15px] font-semibold text-white"
            >
              Start Free
            </StartFreeLink>
          </div>
        </div>
      )}
    </nav>
  );
}
